import Link from "@irati/ui/src/Link"
import {Body, H4} from "@irati/ui/src/Typography"
import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import React, {FC} from "react"

interface Props extends InjectIntl {}

const ShippingInfo: FC<Props> = ({formatMessage}) => (
  <div>
    <H4 marginTop={2} marginBottom={1} wordBreak="break-word">
      <FormattedMessage id="flexiRewards.merchandise.info.shippingInfo.header" />
    </H4>
    <Body>
      <FormattedMessage id="flexiRewards.merchandise.info.shippingInfo.body">
        {(msg: string) => (
          // eslint-disable-next-line react/no-danger
          <div dangerouslySetInnerHTML={{__html: msg.replace(/-/g, "<br />")}} />
        )}
      </FormattedMessage>
    </Body>
    <Body marginTop={2}>
      <FormattedMessage id="flexiRewards.merchandise.info.shippingInfo.readMore" />
      <Link href={formatMessage({id: "flexiRewards.merchandise.info.shippingInfo.policyUrl"})} target="__blank" marginLeft={0.5}>
        <FormattedMessage id="flexiRewards.merchandise.info.shippingInfo.policy" />
      </Link>
    </Body>
  </div>
)

export default injectIntl(ShippingInfo)
